{
  "version": 1,
  "asset_id": "7e7028aa-f075-4c49-afb8-117eaba8a55b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7e7028aa-f075-4c49-afb8-117eaba8a55b/lap-band-removed-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7e7028aa-f075-4c49-afb8-117eaba8a55b/lap-band-removed-800.jpg",
  "original_filename": "lap-band-removed-800.jpg",
  "size": 78056,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T00:12:00Z"
}
